import { DpPalette } from '@/styles/Ruby/palette';

// Colores de los elementos de cupón, tomados de la paleta de DPStreet.
export const COUPON_COLORS = {
	surface: DpPalette.PRIMARY_LIGHT,
	border: DpPalette.BORDER_DEFAULT,
	text: 'text.primary',
	textSecondary: 'text.secondary',
	accent: DpPalette.SECONDARY_DEFAULT,
	accentHover: DpPalette.SECONDARY_DARK,
	accentText: DpPalette.TEXT_DARK,
};
